import { TColor } from "../../../type/color-type";
import ReturnStatusEnum from "./enumReturnStatus";

export interface IStatusBadgeItem {
    label: string;
    color: TColor;
}

enum WorkResourceEmployeeStatusEnum {
    notDelivered,
    delivered,
    returned,
    changed,
    notSigned
}

const statusLabels: Record<WorkResourceEmployeeStatusEnum, string> = {
    [WorkResourceEmployeeStatusEnum.notDelivered]: 'Não entregue',
    [WorkResourceEmployeeStatusEnum.delivered]: 'Entregue',
    [WorkResourceEmployeeStatusEnum.returned]: 'Devolvido',
    [WorkResourceEmployeeStatusEnum.changed]: 'Trocado',
    [WorkResourceEmployeeStatusEnum.notSigned]: 'Não Assinado',
};

const returnLabels: Record<ReturnStatusEnum, string> = {
    [ReturnStatusEnum.none]: '-',
    [ReturnStatusEnum.regularWearTear]: 'Desgaste normal',
    [ReturnStatusEnum.lost]: 'Perda',
    [ReturnStatusEnum.damaged]: 'Danificado',
    [ReturnStatusEnum.replacement]: 'Substituição',
    [ReturnStatusEnum.change]: 'Troca',
};

const statusColors: Record<WorkResourceEmployeeStatusEnum, TColor> = {
    [WorkResourceEmployeeStatusEnum.notDelivered]: 'warning',
    [WorkResourceEmployeeStatusEnum.delivered]: 'success',
    [WorkResourceEmployeeStatusEnum.returned]: 'warning',
    [WorkResourceEmployeeStatusEnum.changed]: 'info',
    [WorkResourceEmployeeStatusEnum.notSigned]: 'danger',
};

export function getStatusBadge (status: WorkResourceEmployeeStatusEnum): IStatusBadgeItem {
    return {
        label: statusLabels[status],
        color: statusColors[status],
    };
};

export function getReturnReason(returnStatus: ReturnStatusEnum): string {
    return returnLabels[returnStatus];
}

export default WorkResourceEmployeeStatusEnum;
